import React, { Component, } from 'react';
import InputText from "../../../../common/components/input-text/input-text";
import Cx from "classnames";
import { getEmail, getUserCompanyId, getUserId } from '../../../../utils/common';

class AddLoadingGang extends Component {
    constructor(props){
        super(props);
        this.state = {
            warehouse_id: this.props.data ? this.props.data.warehouse_id : '',
            gang_code: this.props.data ? this.props.data.gang_code : '',
            labour_code: this.props.data ? this.props.data.labour_code : '',
            vendor_code: this.props.data ? this.props.data.vendor_id : '',
            vendor_name: this.props.data ? this.props.data.name : '',
            branch_code: this.props.data ? this.props.data.branch_code : '',
            previous_data: this.props.data?this.props.previous_data:null,
        }
    }

    onChangeHandler = (value, id) =>{
        this.setState({
            [id] : value.toUpperCase()
        })
    }

    onSave = () => {
        this.props.onAddLoadingGang(this.state);
        this.props.toggleAdd();
    }

    onUpdate = () => {
        let details = this.state;
        if(this.props.data.id)
            details.id = this.props.data.id;
            details.previous_data.user_id = getUserId();
            details.previous_data.user_email = getEmail();
            details.previous_data.update_flag = true;
            details.previous_data.master_type = 12;
            details.previous_data.company_id = this.props.company_id;
            details.previous_data.vendor_code = this.props.previous_data.vendor_id;
            details.previous_data.vendor_name = this.props.previous_data.name;
        this.props.updateLodingGang(details);
        this.props.toggleAdd();
    }

    render() {

        const { warehouse_id, gang_code, vendor_code, vendor_name, labour_code, branch_code } = this.state;
        const { data } = this.props;

        return (
            <div className = "add-user-wrap add-bay">
                <div onClick = {this.props.toggleAdd} className = "overlay"></div>
                <div id = "modal" className = "modal-popup">
                    <div className = "pop-heading">
                        {`${data ? 'Edit' : 'Add' } Vendor`}
                    </div>
                    <div className = "content add-edit-user">
                        <form className = "form-section" autoComplete = "nope">
                            <InputText placeholder = "Vendor Name" id = {"vendor_name"} label = "Vendor Name" value = {vendor_name} changeHandler = {this.onChangeHandler}/>
                            <InputText placeholder = "Vendor Code" id = {"vendor_code"} label = "Vendor Code" value = {vendor_code} changeHandler = {this.onChangeHandler} />
                            <InputText placeholder = "Gang Code" id = {"gang_code"} label = "Gang Code" value = {gang_code} changeHandler = {this.onChangeHandler} />
                            <InputText placeholder = "Labour Code" id = {"labour_code"} label = "Labour Code" value = {labour_code} changeHandler = {this.onChangeHandler} />
                            <InputText placeholder = "Warehouse Id" id = {"warehouse_id"} label = "Warehouse Id" value = {warehouse_id} changeHandler = {this.onChangeHandler} />
                            <InputText placeholder = "Branch Code" id = {"branch_code"} label = "Branch Code" value = {branch_code} changeHandler = {this.onChangeHandler} />
                        </form>

                        <div className = "submit-section">
                            <button className = "add-button discard" onClick={this.props.toggleAdd} >Cancel</button>
                            {!data  ? <button className = {Cx("add-button", {
                                'disable-btn' : !(warehouse_id && gang_code && vendor_code && vendor_name && labour_code && branch_code)
                            })} onClick={this.onSave}>Save</button> :
                            <button className = {Cx("add-button", {
                                'disable-btn' : !(warehouse_id && gang_code && vendor_code && vendor_name && labour_code && branch_code)
                            })} onClick={this.onUpdate}>Update</button>
                    
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddLoadingGang;
